/* RESPONSIBLE TEAM: team-proactive-support */

export const SEARCH_URL = '/ember/content_service/contents/search';
export const GET_STATS_URL = '/ember/content_service/contents/get_stats';
export const UPDATE_TAGGING_URL = '/ember/content_service/tags/update';
export const BULK_TAGGING_URL = '/ember/content_service/tags/bulk_tag';
export const BULK_DEACTIVATE_URL = '/ember/content_service/deactivate/bulk_deactivate';
export const BULK_ARCHIVE_URL = '/ember/content_service/archive/bulk_archive';
export const BULK_ARCHIVE_TOURS_TOOLTIPS_CHECKLISTS_URL =
  '/ember/content_service/archive/bulk_archive_tours_tooltips_checklists';
export const GROUP_BY_TYPE_URL = '/ember/content_service/group_by_type';
export const INSERTABLE_CONTENT_URL = '/ember/content_service/insertable_content';
